export const FORM_DATA = {
  companyName: '',
  projectName: '',
  compareSpecModelA: '',
  compareSpecModelB: '',
  compareComponentTypeA: '',
  compareComponentTypeB: '',
  compareBatteryTechA: '',
  compareBatteryTechB: '',
  glassTypeA: '',
  glassTypeB: '',
  compareCapacityA: '',
  compareCapacityB: '',
  supportType: '',
  componentHeightA: '',
  componentHeightB: '',
  componentPriceA: '',
  componentPriceB: '',
  city: '',
  groundType: '',
  surfaceType: '',
  dcCapacity: '',
  capacityRatio: '',
  inverterType: '组串式',
  outputCable: '铝合金',
  pvModuleInstallBilling: '按块计费',
  hasProjectMinTemperature: false,
  hasGlassAngleConsistent: false,
  hasSeriesBlockVoltageCorrected: true,
  hasFreightIncludedInPrice: false,
  hasEnergyStorage: false,
  hasSpecifiedElectPrice: false,
  projectMinTemperature: '',
  specifiedElectPrice: '',
}

export const RULES = Object.freeze({
  companyName: [
    { required: true, message: '请输入', trigger: 'blur' }
  ],
  projectName: [
    { required: true, message: '请输入', trigger: 'blur' }
  ],
  compareSpecModelA: [
    { required: true, message: '请输入对比产品', trigger: 'blur' } 
  ],
  compareSpecModelB: [
    { required: true, message: '请输入推荐产品', trigger: 'blur' } 
  ],
  compareComponentTypeA: [
    { required: true, message: '请选择对比组件', trigger: 'change' } 
  ],
  compareComponentTypeB: [
    { required: true, message: '请选择推荐组件', trigger: 'change' }
  ],
  compareBatteryTechA: [
    { required: true, message: '请选择对比电池技术', trigger: 'change' }  
  ],
  compareBatteryTechB: [
    { required: true, message: '请选择推荐电池技术', trigger: 'change' } 
  ],
  glassTypeA: [
    { required: true, message: '请选择', trigger: 'change' } 
  ],
  glassTypeB: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  compareCapacityA: [
    { required: true, message: '请选择', trigger: 'change' } 
  ],
  compareCapacityB: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  supportType: [
    { required: true, message: '请选择支架类型', trigger: 'change' } 
  ],
  componentHeightA: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  componentHeightB: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  componentPriceA: [
    { required: true, message: '请输入', trigger: 'change' } 
  ],
  componentPriceB: [
    { required: true, message: '请输入', trigger: 'change' } 
  ],
  city: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  groundType: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  surfaceType: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  dcCapacity: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  // capacityRatio: [
  //   { required: true, message: '请输入', trigger: 'change' }
  // ],
  inverterType: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  outputCable: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  pvModuleInstallBilling: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasProjectMinTemperature: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasGlassAngleConsistent: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasSeriesBlockVoltageCorrected: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasFreightIncludedInPrice: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasEnergyStorage: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasSpecifiedElectPrice: [
    { required: true, message: '请选择', trigger: 'change' } 
  ],
  projectMinTemperature: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  specifiedElectPrice: [
    { required: true, message: '请输入', trigger: 'change' } 
  ],
})

export const SELECT_FORM_DATA = {
  companyName: '',
  projectName: '',
  model: '',
  fixedComponentHeight: '',
  softComponentHeight: '',
  trackComponentHeight: '',
  componentPrice: '',
  city: '',
  groundType: '',
  surfaceType: '',
  dcCapacity: '',
  capacityRatio: '',
  pvModuleInstallBilling: '按块计费',
  hasProjectMinTemperature: false,
  projectMinTemperature: '',
  hasGlassAngleConsistent: false,
  hasSeriesBlockVoltageCorrected: true,
  hasFreightIncludedInPrice: false,
  hasEnergyStorage: false,
  storageCapacityRatio: '',
  storageConfigTime: '',
  hasSpecifiedElectPrice: false,
  specifiedElectPrice: '',
}

export const SELECT_RULES = Object.freeze({
  companyName: [
    { required: true, message: '请输入', trigger: 'blur' }
  ],
  projectName: [
    { required: true, message: '请输入', trigger: 'blur' }
  ],
  model: [
    { required: true, message: '请选择', trigger: 'blur' } 
  ],
  fixedComponentHeight: [
    { required: true, message: '请输入', trigger: 'change' }  
  ],
  softComponentHeight: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  trackComponentHeight: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  componentPrice: [
    { required: true, message: '请输入', trigger: 'change' } 
  ],
  city: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  groundType: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  surfaceType: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  dcCapacity: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  capacityRatio: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  pvModuleInstallBilling: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasProjectMinTemperature: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasGlassAngleConsistent: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasSeriesBlockVoltageCorrected: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasFreightIncludedInPrice: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasEnergyStorage: [
    { required: true, message: '请选择', trigger: 'change' }
  ],
  hasSpecifiedElectPrice: [
    { required: true, message: '请选择', trigger: 'change' } 
  ],
  projectMinTemperature: [
    { required: true, message: '请输入', trigger: 'change' }
  ],
  specifiedElectPrice: [
    { required: true, message: '请输入', trigger: 'change' } 
  ],
})